import React from 'react';

import { ProcedureInfoStyle, ProcedureInformationText } from './styled';
import IDHelpers from '@/core/helpers/IDHelper';
import Link from '@/presentation/reusables/Link';

const ProcedureInfoComponent = ({ deliverySchedule }: any) => (
  <ProcedureInfoStyle>
    <div className="requirements__container">
      <p className="requirements__container--question">
        <strong>¿Qué requisitos necesito?</strong>
      </p>
      <ProcedureInformationText>
        <div>
          <ul>
            <li>
              Tener registrada tu fotografía para trámites formales. Si aún no
              lo realizas, hazlo en{' '}
              <Link
                linkType="internal"
                url="/tramites/autogestionables/registro-foto"
                linkName="registrar foto."
              />
            </li>
            <li>Estar matriculado en el presente ciclo.</li>
            <li>No estar suspendido por medidas disciplinarias.</li>
          </ul>
        </div>
      </ProcedureInformationText>
      <p className="requirements__container--question">
        <strong>Cronograma de entrega de carné</strong>
      </p>
      <ProcedureInformationText>
        {deliverySchedule && (
          <div style={{ margin: '2px 0px 8px 24px' }}>
            <ol style={{ listStyle: 'disc' }}>
              {deliverySchedule?.map((r: string) => (
                <li key={IDHelpers.generateID()}>{r}</li>
              ))}
            </ol>
          </div>
        )}
      </ProcedureInformationText>
      <p className="requirements__container--question">
        <strong>Consideraciones</strong>
      </p>
      <ProcedureInformationText style={{ marginBottom: '-10px' }}>
        <div>
          <ul>
            <li>
              La fecha máxima es hasta el pago hecho y cerrada la solicitud,
              sino no se considerará.
            </li>
            <li>La vigencia del carné es de 1 año desde su emisión.</li>
            <li>
              Podrás solicitar tu carné universitario a partir del mismo periodo
              del siguiente año (Ej. Si solicitaste tu carné en agosto 2023, te
              corresponderá solicitarlo a partir de agosto 2024).
            </li>
          </ul>
        </div>
      </ProcedureInformationText>
    </div>
  </ProcedureInfoStyle>
);

const StepsToFollowComponent = ({ stepsToFollow }: any) => (
  <ProcedureInfoStyle>
    <div className="requirements__container">
      <p className="requirements__container--question">
        <strong>Pasos a seguir:</strong>
      </p>
      <ProcedureInformationText>
        {stepsToFollow && (
          <div style={{ margin: '12px 0px 0px 20px' }}>
            <ol style={{ listStyle: 'decimal' }}>
              {stepsToFollow?.map((r: string) => (
                <li key={IDHelpers.generateID()}>{r}</li>
              ))}
            </ol>
          </div>
        )}
      </ProcedureInformationText>
    </div>
  </ProcedureInfoStyle>
);

export { ProcedureInfoComponent, StepsToFollowComponent };
